/**
 * 获取URL查询参数
 * @param {string} [key] - 可选，参数名
 * @param {string} [url] - 可选，要解析的URL，默认当前页面URL
 * @returns {string|object|null} 返回参数值或参数对象
 */
export function getUrlParams(key, url = window.location.href) {
    try {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      
      // 如果没有传入key，返回所有参数的对象
      if (key === undefined) {
        const result = {};
        for (const [k, v] of params.entries()) {
          // 处理重复参数（转为数组）
          if (result.hasOwnProperty(k)) {
            result[k] = Array.isArray(result[k]) 
              ? [...result[k], v] 
              : [result[k], v];
          } else {
            result[k] = v;
          }
        }
        return result;
      }
      
      // 如果传入了key，返回对应的值
      if (params.has(key)) {
        return params.get(key);
      }
      
      return null;
    } catch (error) {
      console.error('解析URL参数失败:', error);
      return null;
    }
  }